import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken, getDateRange, getUserSettings} from '../../storage'
import moment from 'moment'
import {DRN} from './daterange'
import {Link } from 'react-router-dom'
import Select from 'react-select';
import {Currency} from '../../utils/currency'
import _ from 'lodash'

class TypeFormat extends React.Component {
  render() {

    let row = this.props.row
    if(row.original.type === "Invoice") {

      let settings = this.props.settings

      let invoice_full_id = row.original.series_name + row.original.series_counter
        if(settings && settings.options && settings.options['append_series_name_as_suffix']) {
          invoice_full_id = row.original.series_counter + row.original.series_name
        }


      return <Link to={'/invoices/preview/'+row.original.serial}>{row.original.type} {invoice_full_id}</Link>
    }
    else if(row.original.type === "Purchase") {
      return <Link to={'/purchases/preview/'+row.original.serial}>{row.original.type} {row.original.serial}</Link>
    }
    else if(row.original.type === "Credit Note") {

      if(row.original.is_generalnote) {
        return <Link to={'/general_credit_notes/edit/'+row.original.serial}>General Credit Note {row.original.serial}</Link>
      }
      else {
        return <Link to={'/credit_notes/preview/'+row.original.serial}>{row.original.type} {row.original.serial}</Link>
      }
    }
    else if(row.original.type === "Debit Note") {

      if(row.original.is_generalnote) {
        return <Link to={'/general_debit_notes/edit/'+row.original.serial}>General Debit Note {row.original.serial}</Link>
      }
      else {
        return <Link to={'/debit_notes/preview/'+row.original.serial}>{row.original.type} {row.original.serial}</Link>
      }
    }
    else if(row.original.type === 'Receipt') {
      const invoice = row.original.invoice
      if(typeof invoice !== "undefined" && invoice !== null && invoice.serial) {
        return <span>{row.original.type} <Link to={'/invoices/edit/'+invoice.serial}>Invoice {invoice.series_name + "" + invoice.series_counter}</Link></span>
      }
      else {
        return <span>{row.original.type}</span>
      }
    }
    else if(row.original.type === 'Payment') {
      const purchase = row.original.purchase

      if(typeof purchase !== "undefined" && purchase !== null  && typeof purchase.serial !== "undefined") {
        return <span>{row.original.type} <Link to={'/purchases/edit/'+purchase.serial}>Purchase {purchase.serial}</Link></span>
      }
      else {
          return <span>{row.original.type}</span>
      }

    }
    else if(row.original.type === 'Expense') {
      const expense = row.original
      if(typeof expense !== "undefined" && expense !== null  && typeof expense.id !== "undefined") {
        return <span><Link to={'/expenses/edit/'+expense.id}>Expense {expense.id} </Link></span>
      }
      else {
          return <span>{row.original.type}</span>
      }

    }
    else {
      return null
    }

  }
}

class PersonFormat extends React.Component {
  render() {

    let original = this.props.row.original
    if(original.type === "Invoice" || original.type === "Credit Note" || original.type === "Receipt") {
      const client = original.client
      const department = original.department
      if(typeof client !== "undefined" && client !== null) {
        return <Link to={'/clients/edit/'+client.id}>{client.name} {client.city}</Link>
      }
      else if (department !== "undefined" && department !== null) {
        return <Link to={'/costcenters/edit/'+department.id}>{department.name} </Link>
      }
    }
    else if(original.type === "Purchase" || original.type === "Debit Note" || original.type === 'Payment') {
      const supplier = original.supplier
      if(typeof supplier !== "undefined" && supplier !== null) {
        return <Link to={'/suppliers/edit/'+supplier.id}>{supplier.name} {supplier.city}</Link>
      }
    }
    else if(original.type === "Expense") {
      return <span>{original.name}</span>
    }
    return null
  }
}

class CreditFormat extends React.Component {
  render() {

    let original = this.props.row.original
    if(original.type === "Purchase") {
      return <div className="text-right">{original.total}</div>
    }
    else if(original.type === "Credit Note") {
      return <div className="text-right">{original.total}</div>
    }
    else if (original.type === 'Receipt') {
      return <div className="text-right">{original.total}</div>
    }
    return null
  }
}

class DebitFormat extends React.Component {
  render() {

    let original = this.props.row.original
    if(original.type === "Invoice" ) {
      return <div className="text-right">{original.total}</div>
    }
    else if (original.type === "Debit Note") {
      return <div className="text-right">{original.total}</div>
    }
    else if (original.type === 'Payment') {
      return <div className="text-right">{original.total}</div>
    }
    else if (original.type === 'Expense') {
      return <div className="text-right">{original.total}</div>
    }
    return null
  }
}

class CreditedHeader extends React.Component {

  render() {
    let data = this.props.data
    if(data.length > 0) {
      let total = _.sum(_.map(data, d=>{

        if(d.type === "Credit Note") {
          return parseFloat(d.total)
        }
        else if (d.type === "Purchase") {
          return parseFloat(d.total)
        }
        else if(d.type === 'Receipt') {
          return parseFloat(d.total)
        }
        else {
          return 0
        }

      })).toFixed(2)

      return <div className="text-right">Inwards <Currency />
        <div>
          {total}
        </div>
      </div>
    }
    else {
      return null
    }
  }
}

class DebitedHeader extends React.Component {

  render() {
    let data = this.props.data
    if(data.length > 0) {
      let total = _.sum(_.map(data, d=>{
        if(d.type === "Debit Note" ) {
          return parseFloat(d.total)
        }
        else if(d.type === "Invoice") {
          return parseFloat(d.total)
        }
        else if(d.type === 'Payment') {
          return parseFloat(d.total)
        }
        else if(d.type === 'Expense') {
          return parseFloat(d.total)
        }
        else {
          return 0
        }

      })).toFixed(2)

      return <div className="text-right">Outwards <Currency />
        <div>
          {total}
        </div>
      </div>
    }
    else {
      return null
    }
  }
}

export default class Daylog extends React.Component {

  constructor(props){
    super(props)
    let dateRange = getDateRange()
    this.fetchData = this.fetchData.bind(this)
    this.applyDateRange= this.applyDateRange.bind(this)
    this.handleTypeChange = this.handleTypeChange.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.getClientOrSupplier = this.getClientOrSupplier.bind(this)

    this.state = {
      tableState: {},
      data: [],
      records: null,
      loading: true,
      dateRange : dateRange,
      types: [],
      client_or_supplier : null
    };
      document.title = "Day Book"
  }

  fetchData(state, instance, dateRange=this.state.dateRange, types=this.state.types, client_or_supplier=this.state.client_or_supplier) {
    this.setState({ loading: true });

    let apiurl = "/list_ledgers/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_desc='+state.sorted[0]['desc']
    }

    if(types.length > 0) {
      types.forEach((type)=>{
        apiurl = apiurl + '&type='+type.value
      })
    }

    if(client_or_supplier !== null) {
      if(client_or_supplier.type === "Client") {
        apiurl = apiurl + '&client_id='+client_or_supplier.id
      }
      else if(client_or_supplier.type === "Department") {
        apiurl = apiurl + '&department_id='+client_or_supplier.id
      }
      else {
        apiurl = apiurl + '&supplier_id='+client_or_supplier.id
      }
    }

    // if(brand_id) {
    //   apiurl = apiurl + '&brand_id='+ brand_id
    // }
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    this.setState({tableState:state, types:types, dateRange:dateRange, client_or_supplier:client_or_supplier})
    axios({
      url: apiurl,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then(res => {
      this.setState({
        data: res.data.book,
        records: <p><span className="label label-info">{res.data.book.length + " Records"}</span></p>,
        loading: false
      });
    }).catch((err)=>{
      this.setState({loading:false})
    })
  }

  handleNameChange(value) {
    this.setState({client_or_supplier: value})
    this.fetchData(this.state.tableState, {}, this.state.dateRange, this.state.types, value)
  }

  getClientOrSupplier (input) {

    let settings = getUserSettings()
    let clientOrSupplierUrl = '/list_client_or_suppliers/?name='+input
    if(settings && settings.options && settings.options.enable_departments) {
      clientOrSupplierUrl = '/list_client_or_suppliers/?enable_departments=true&name='+input
    }

    return   axios({
        url: clientOrSupplierUrl,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data}
      }).catch((err)=> {
        console.log(err);
        return Promise.resolve({ options: [] });
      })
}


  handleTypeChange(types) {
    this.setState({types:types})
    this.fetchData(this.state.tableState, {}, this.state.dateRange, types)
  }

  applyDateRange(dateRange){
    this.fetchData(this.state.tableState, {}, dateRange)
  }

  dateFormat(row) {

    return <span>{moment(row.original.date).format('DD-MM-YYYY')}</span>
  }


  renderOption(option){
    return <span>{option.name} {option.city}<label className="label label-info small">{option.type ==="Department" ? "CostCenter": option.type}</label> </span>
  }

  downloadReport = (report_type) => {
    return   axios({
      url: report_type,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  downloadLog = () => {
    let state = this.state.tableState, dateRange=this.state.dateRange, types=this.state.types, client_or_supplier=this.state.client_or_supplier

    let apiurl = "/export_daylog_excel/?page=" + state.page + '&page_size='+state.pageSize;
    if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
        apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
        apiurl = apiurl + '&sort_desc='+state.sorted[0]['desc']
    }

    if(types.length > 0) {
      types.forEach((type)=>{
        apiurl = apiurl + '&type='+type.value
      })
    }

    if(client_or_supplier !== null) {
      if(client_or_supplier.type === "Client") {
        apiurl = apiurl + '&client_id='+client_or_supplier.id
      }
      else {
        apiurl = apiurl + '&supplier_id='+client_or_supplier.id
      }
    }

    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }

    this.downloadReport(apiurl).then((response)=> {
      this.setState({submitting_rate_sales:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_rate_sales:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }



  render() {
    let settings = getUserSettings();
    let clientHeader = "Name"
    if(settings && settings.options && settings.options.enable_departments){
      clientHeader = "CostCenter/Supplier"
    }
    const { data, pages, loading } = this.state;

    const columns = [
      {Header:'Date', accessor: 'date',sortable:true, Cell:(row)=>{return this.dateFormat(row)} },
      {Header:clientHeader, sortable:false, Cell:(row)=>(<PersonFormat row={row}/>) },
      {Header:'Type', accessor: 'type',sortable:false, Cell:(row)=>(<TypeFormat row={row} settings={settings} />) },
      {Header:(<CreditedHeader data={data} />), accessor: 'totalPrice',sortable:false,
        Cell:(row)=>(<CreditFormat row={row} />),
        Footer: (<CreditedHeader data={data} />)
      },
      {Header: (<DebitedHeader data={data} />), accessor: 'totalPrice',sortable:false,
      Cell:(row)=>(<DebitFormat row={row} />),
      Footer: (<DebitedHeader data={data} />)
     },
    ];
    const defaultSort=[{id: "date", desc: true}]

    const options = [

      {value:'invoice', label:'Invoices'},
      {value:'purchase', label:'Purchases'},
      {value:'credit_note', label:'Credit Notes'},
      {value:'debit_note', label:'Debit Notes'},
      {value:'receipt', label:'Receipts'},
      {value:'payment', label:'Payments'},
      {value:'expense', label:'Expenses'},
    ]

    return <div><section className="medium">
    <div className="row">
      <div className="col-sm-3">
        <h3>Day Book</h3>
      </div>
      <div className="col-sm-3">
        <div className="row mtop">
        <div className="col-md-2 hidden-xs">
          <h4 className="filter-label">Name</h4>
        </div>

        <div className="col-md-10">
          <Select.Async multi={false} onChange={this.handleNameChange} value={this.state.client_or_supplier}
          valueRenderer = {this.renderOption}
          optionRenderer={this.renderOption} valueKey="id" labelKey="name" loadOptions={this.getClientOrSupplier} backspaceRemoves={true} />

        </div>
        </div>
      </div>
      <div className="col-sm-3">
      <div className="row mtop">
      <div className="col-md-2 hidden-xs">
        <h4 className="filter-label">Type</h4>
      </div>
      <div className="col-md-10">
        <Select multi={true} onChange={this.handleTypeChange}  openOnFocus={true} options={options} value={this.state.types} />
      </div>
      </div>


      </div>
      <div className="col-sm-3 ">
        <div className="row mtop">
          <div className="col-md-2 hidden-xs">
            <h4 className="filter-label">Date</h4>
          </div>
          <div className="col-md-10">
          <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
          </div>
        </div>


      </div>
    </div>
    </section>
    <div className="row">

      <div className="col-sm-12">
        <div className="row">
            <div className="col-xs-6">
              {this.state.records}
            </div>
            <div className="col-xs-6">
              <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.downloadLog()}}>Download xls</button></div>
            </div>
        </div>


        <div className="table-responsive">
          <ReactTable defaultSorted={defaultSort}
            getTrProps={this.handleTrclick}
            noDataText="No Records Found."
              columns={columns} manual data={data}
              pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
            <p></p>
        </div>
      </div>
    </div>

    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/report/daylog.js